<template>
  <form action="#"
        method="POST"
        class="contactus-form"
        ref="contactForm"
        @submit.prevent="sendContacts">
    <div class="input-field">
      <input
        type="email"
        v-model.trim="contactForm.emailField"
        placeholder="Email"
        :class="{ hasError: !emailValid }"
        @blur="onBlur('emailField')">
      <span
        class="error-message"
        v-if="!emailValid">
        {{ errors.emailField.message }}
      </span>
    </div>
    <div class="input-field">
      <textarea
        v-model.trim="contactForm.messageField"
        placeholder="Your question"
        :class="{ hasError: !messageValid }"
        @blur="onBlur('messageField')">
        </textarea>
      <span
        class="error-message"
        v-if="!messageValid">
        {{ errors.messageField.message }}
      </span>
    </div>
    <button
      class="btn btn--default"
      type="submit"
      :disabled="!isFormValid">
      Send
    </button>
  </form>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      contactForm: {
        emailField: null,
        messageField: null,
      },
      errors: {
        emailField: {
          invalid: false,
          message: 'Email should not be empty',
        },
        messageField: {
          invalid: false,
          message: 'Question field should not be empty',
        },
      },
    };
  },
  computed: {
    emailValid() {
      return this.contactForm.emailField === null || this.contactForm.emailField;
    },
    messageValid() {
      return this.contactForm.messageField === null || this.contactForm.messageField;
    },
    isFormValid() {
      return this.contactForm.emailField && this.contactForm.messageField;
    },
  },
  methods: {
    ...mapMutations(['hideModal']),
    ...mapActions({ sendContactData: 'contactUs/contacts:send' }),
    onBlur(field) {
      if (this.contactForm[field] === null) {
        this.contactForm[field] = '';
      }
    },
    sendContacts() {
      if (!this.isFormValid) return;
      const { contactForm } = this.$refs;
      const formData = new FormData(contactForm);
      formData.append('email', this.contactForm.emailField);
      formData.append('text', this.contactForm.messageField);
      this.sendContactData(formData)
        .then(() => {
          this.hideModal();
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ContactUsForm.vue